function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);




// itg js 

$(document).ready(function(){
  
  var payment = 'false';
  
  $(window).scroll(function(){
    var scrTop = $(this).scrollTop();
    if(scrTop > 180){
      $('div#shopify-section-header-2').css('display','block');
    }else{
      $('div#shopify-section-header-2').css('display','none');
    }
  });

  $('.next_btn').click(function(){
    var check = $(this).parents('.cart_form_comn').hasClass('cart_from_step_first');
    
    if(check){
          var fName = $('input#firstNameField').val().trim(),
          lName = $('input#lastNameField').val().trim(),
          birthdate = $('input#Birthdate').val().trim(),
          email = $('input#emailField').val().trim(),
          phone = $('input#mobileField').val().trim(),
          addFirst = $('input#addFirstField').val().trim(),
          addSec = $('input#addSecField').val().trim(),
          postCode = $('input#postcode').val().trim(),
          city = $('input#formcity').val().trim();
        
          if(fName == ''){
            $('input#firstNameField').parents('.form-group').addClass('error');
          }else{
            $('input#firstNameField').parents('.form-group').removeClass('error');
          }
        
          if(lName == ''){
            $('input#lastNameField').parents('.form-group').addClass('error');
          }else{
            $('input#lastNameField').parents('.form-group').removeClass('error');
          }
          if(birthdate == ''){
            $('input#Birthdate').parents('.form-group').addClass('error');
          }else{
            $('input#Birthdate').parents('.form-group').removeClass('error');
          }
        
          let result = email.includes("@");
          var mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
          if(email == '' || result == false || email.match(mailformat) == null){
            $('input#emailField').parents('.form-group').addClass('error');
          }else{
            $('input#emailField').parents('.form-group').removeClass('error');
          }
        
          var phoneno = /^\d{11}$/;
          if(phone == '' || phone.match(phoneno) == null){
            $('input#mobileField').parents('.form-group').addClass('error');
          }else{
            $('input#mobileField').parents('.form-group').removeClass('error');
          }

          if(addFirst == ''){
            $('input#addFirstField').parents('.form-group').addClass('error');
          }else{
            $('input#addFirstField').parents('.form-group').removeClass('error');
          }

          if(postCode == ''){
            $('input#postcode').parents('.form-group').addClass('error');
          }else{
            $('input#postcode').parents('.form-group').removeClass('error');
          }

          if(city == ''){
            $('input#formcity').parents('.form-group').addClass('error');
          }else{
            $('input#formcity').parents('.form-group').removeClass('error');
          }
        
          if(fName != '' && lName != '' && email != '' && phone != '' && city !='' && postCode !='' && addFirst !='' && result && email.match(mailformat) && phone.match(phoneno)){
            $(this).parents('.cart_form_comn').removeClass('active');
            $(this).parents('.cart_form_comn').next().addClass('active');
            $('.second_step_indecater').addClass('is-on');
          }
      
    }else if($(this).parents('.cart_form_comn').hasClass('cart_from_step_second')){
      
          var checkValue = $('input[name="payment"]:checked').val();
          
          if(checkValue == 'voucher'){
            
            $(this).parents('.cart_form_comn').removeClass('active');
            $('.cart_from_step_fourth').addClass('active');
            $('.cart_from_step_third input').val('');
            $('.cart_from_step_third input').attr('readonly',false);
            payment = 'voucher';
            $('.third_step_indecater').addClass('is-on');
            
          }else if(checkValue == 'plant-trees'){
            
            $(this).parents('.cart_form_comn').removeClass('active');
            $('.cart_from_step_fourth').addClass('active');
            $('.third_step_indecater').addClass('is-on');
            $('.cart_from_step_third input').val('');
            $('.cart_from_step_third input').attr('readonly',false);
            payment = 'plant-trees';
            
          }else if(checkValue == 'donation'){
            
            $(this).parents('.cart_form_comn').removeClass('active');
            $('.cart_from_step_fourth').addClass('active');
            $('.third_step_indecater').addClass('is-on');
            $('.cart_from_step_third input').val('');
            $('.cart_from_step_third input').attr('readonly',false);
            payment = 'donation';
            
          }else if(checkValue == 'paypal'){
            
            $(this).parents('.cart_form_comn').removeClass('active');
            $(this).parents('.cart_form_comn').next().addClass('active');
            $('.cart_from_step_third').addClass('paypal');
            $('.cart_from_step_third .form-group').removeClass('error');
            $('.cart_from_step_third input[type="text"]').attr('readonly',true);
            $('.cart_from_step_third input[type="email"]').attr('readonly',false);
            $('.cart_from_step_third input[type="text"]').val('');
            payment = 'paypal';
            
          }else if(checkValue == 'bank'){
            
            $(this).parents('.cart_form_comn').removeClass('active');
            $(this).parents('.cart_form_comn').next().addClass('active');
            $('.cart_from_step_third').removeClass('paypal');
            $('.cart_from_step_third .form-group').removeClass('error');
            $('.cart_from_step_third input[type="email"]').val('');
            $('.cart_from_step_third input[type="email"]').attr('readonly',true);
            $('.cart_from_step_third input[type="text"]').attr('readonly',false);
            payment = 'bank';
            
          }
        else if(checkValue == 'BSE'){
            
            $(this).parents('.cart_form_comn').removeClass('active');
            $(this).parents('.cart_form_comn').next().addClass('active');
            $('.cart_from_step_third').removeClass('paypal');
            $('.cart_from_step_third .form-group').removeClass('error');
            $('.cart_from_step_third input[type="email"]').val('');
            $('.cart_from_step_third input[type="email"]').attr('readonly',true);
            $('.cart_from_step_third input[type="text"]').attr('readonly',false);
            payment = 'BSE';
            
          }
      
    }else{
      
        var acc = $('input#accountName').val().trim(),
        accNo = $('input#accountNo').val().trim(),
        sortCode = $('input#sortCode').val().trim(),
        paypalEmail = $('input#paypalEmail').val().trim();
      
        if(acc == ''){
          $('input#accountName').parents('.form-group').addClass('error');
        }else{
          $('input#accountName').parents('.form-group').removeClass('error');
        }
        
        if(accNo == ''){
          $('input#accountNo').parents('.form-group').addClass('error');
        }else{
          $('input#accountNo').parents('.form-group').removeClass('error');
        }
      
        if(sortCode == ''){
          $('input#sortCode').parents('.form-group').addClass('error');
        }else{
          $('input#sortCode').parents('.form-group').removeClass('error');
        }
      
        let result = paypalEmail.includes("@");
        var mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if(paypalEmail == '' || result == false || paypalEmail.match(mailformat) == null){
          $('input#paypalEmail').parents('.form-group').addClass('error');
        }else{
          $('input#paypalEmail').parents('.form-group').removeClass('error');
        }
      
      if(payment == 'paypal'){
          if(result && paypalEmail.match(mailformat)){
            $(this).parents('.cart_form_comn').removeClass('active');
            $(this).parents('.cart_form_comn').next().addClass('active');
            $('.third_step_indecater').addClass('is-on');
          }
      }else{
          if(acc != '' && accNo != '' && sortCode != ''){
            $(this).parents('.cart_form_comn').removeClass('active');
            $(this).parents('.cart_form_comn').next().addClass('active');
            $('.third_step_indecater').addClass('is-on');
          }
      }
    }
  });
  
  $('.previous_btn').click(function(){
    if(payment == 'plant-trees' || payment=='voucher' || payment=='donation'){
      $(this).parents('.cart_form_comn').removeClass('active');
      $('.cart_from_step_second').addClass('active');
    }else{
      $(this).parents('.cart_form_comn').removeClass('active');
      $(this).parents('.cart_form_comn').prev().addClass('active');
    }
  });

  $(document).on('click','#finish_btn',function () {
    if(document.getElementById("termCheck").checked){
      $('input#termCheck').parents('.form-group').removeClass('error');
        $.getJSON('/cart.js', function(cart) {
          let items = cart.items;
          var cart_token = cart.token;
          var proArray = []; 
          for(var i=0; i < items.length; i++){
            var itemArr = {}; 
            if(items[i].variant_id !='' && items[i].variant_id !=null){
                 var itemVariantId = items[i].variant_id;
            }else{
                 var itemVariantId = '';
            }
            if(items[i].price !='' && items[i].price != null){
                 var itemPriceFinal = items[i].price;
                 var priceDivid = (itemPriceFinal)/100;
                 var itemPrice = priceDivid.toFixed(2); 
            }else{ 
                 var itemPrice = '';
            }
            if(items[i].sku !='' && items[i].sku !=null){
                 var itemSKU = items[i].sku;
            }else{
                 var itemSKU = '';
            }
            if(items[i].quantity !='' && items[i].quantity !=null){
                 var itemQuantity = items[i].quantity;
            }else{
                 var itemQuantity = '';
            }
            if(items[i].product_title !='' && items[i].product_title !=null){
                 var itemProductTitle = items[i].product_title;
            }else{
                 var itemProductTitle = '';
            }
            if(items[i].product_id !='' && items[i].product_id !=null){
                 var itemProductId = items[i].product_id;
            }else{
                 var itemProductId = '';
            }
            if(items[i].image !='' && items[i].image !=null){
                 var itemImage = items[i].image;
            }else{
                 var itemImage = ''; 
            }
            itemArr['variant_id'] = itemVariantId;
            itemArr['price'] = itemPrice;
            itemArr['sku'] = itemSKU;
            itemArr['qty'] = itemQuantity;
            itemArr['product_title'] = itemProductTitle;
            itemArr['product_id'] = itemProductId;
            itemArr['image'] = itemImage; 
            proArray.push(itemArr); 
         } 
        var productData = JSON.stringify(proArray); 
        var firstName = $('input#firstNameField').val().trim(),
          lastName = $('input#lastNameField').val().trim(),
          birthdate = $('input#Birthdate').val().trim(),
          Email = $('input#emailField').val().trim(),
          phoneNo = $('input#mobileField').val().trim(),
          addFirst = $('input#addFirstField').val().trim(),
          addSec = $('input#addSecField').val().trim(),
          postCode = $('input#postcode').val().trim(),
          city = $('input#formcity').val().trim(),
          Acc = $('input#accountName').val().trim(),
          AccNo = $('input#accountNo').val().trim(),
          SortCode = $('input#sortCode').val().trim(),
          paypalEmail = $('input#paypalEmail').val().trim(),
          promocode = $('input.promo-code-field').val().trim(),
          paymentOption = payment;
		  
		  if(Acc!='' && Acc!=undefined){
			var accountName = Acc;
		  }else{
			var accountName = '';  
		  }
		  
		  if(AccNo!='' && AccNo!=undefined){
			var accountNo = AccNo;
		  }else{
			var accountNo = '';  
		  }
		  
		  if(SortCode!='' && SortCode!=undefined){
			var sort_Code = SortCode;
		  }else{ 
			var sort_Code = '';  
		  }

          if(paypalEmail!='' && paypalEmail!=undefined){
			var paypal_email = paypalEmail;
		  }else{ 
			var paypal_email = '';  
		  }
		  
		  if(addSec != '' && addSec != undefined){
            var add_second = addSec;
          }else{
            var add_second = '';
          }
		  
         var data_sent = {
           'cart_status':1,
           'fname':firstName,
           'lname':lastName,
           'birth_date' : birthdate,
           'email':Email,
           'phone_no':phoneNo,
           "promo_code" :promocode,
           'add_first':addFirst,
           'add_sec':add_second,
           'post_code':postCode,
           'city':city,
           'payment_option':paymentOption,
           'account_name':accountName,
           'account_no':accountNo,
           'sort_code':sort_Code,
           'paypal_email':paypal_email,
           'cart_data':productData,
           'cart_token': cart_token
         }
         console.log(data_sent);
          var OrderUrl = 'https://dev.shopifyexperthelp.com/app/bs_exchange_sell/create_order_main.php';
          
		 // location.href = '/pages/order-confirm';
          
			$.ajax({ 
				method: 'post', 
				url: OrderUrl,
				data: data_sent, 
				success: function(resp) { 
					//alert(resp);
					var respData = JSON.parse(resp);
					if (respData['status'] == 1) {  
					//	alert(555);
						var dataUrl = '/pages/order-confirm';
						setTimeout(function () { 
							$.ajax({
							  type: "POST",
							  url: '/cart/clear.js',
							  cache: false, 
							  success: function(){
								  location.href = dataUrl; 
							  },
							});  
						}, 100);
						
					} else { 
						alert('Something went wrong, please try.'); 
					}
				}, 
				error: function() { 
					alert('Something went wrong, please try.');
				}
			});
	
		 
		 
      });
    }else{
      $('input#termCheck').parents('.form-group').addClass('error');
    }
   });

  $('div#shopify-section-header-2 details#Details-menu-drawer-container svg.icon.icon-hamburger').click(function(){
    $('body').addClass('overflow-hidden-tablet');
  $('div#shopify-section-header-2 details#Details-menu-drawer-container div#menu-drawer').css({'visibility':'visible','transform':'translate(0)'});
})
$('div#shopify-section-header-2 details#Details-menu-drawer-container svg.icon.icon-close').click(function(){
    $('body').removeClass('overflow-hidden-tablet');
  $('div#shopify-section-header-2 details#Details-menu-drawer-container div#menu-drawer').css({'visibility':'hidden','transform':'translate(-100%)'});
})

  $('fieldset.js.product-form__input label[for]').click(function(){
    setTimeout(function name(params) {
    var vPrice = $('span.voucher-price').text();
    $('input#voucherPrice').val(vPrice);
    },1000);
  });
  
});

$(document).on('click','.accTrigger',function () {
  $(this).toggleClass('activeAcc');
  $(this).parents('.footer-block').find('.footer-block__details-content').slideToggle();
});

function mediaQuery(x) {
  if (x.matches) { // If media query matches
    $('.footer-block h2').addClass('accTrigger');
  } else {
    $('.footer-block h2').removeClass('accTrigger');
  }
}
var x = window.matchMedia("(max-width: 750px)")
mediaQuery(x) // Call listener function at run time
x.addListener(mediaQuery) // Attach listener function on state changes



$('.drop_down_val_main').click(function(){
    $('.drop_down_selector_main').slideToggle();
});

$('ul.drop_down_list li').click(function(){
   var value = $(this).data('value');
    $('ul.drop_down_list li').removeClass('slected_list');
    $(this).addClass('slected_list');
    $('.drop_down_tab').removeClass('slected_tab');
    $('[data-on="'+value+'"]').addClass('slected_tab');
    $('.drop_down_val span').text(value);
    $('.drop_down_selector_main').slideUp();
});


$("#proCondition_trigger").click(function() {
    $('html, body').animate({
        scrollTop: $("#proCondition").offset().top - 100
    });
});




